import { render, staticRenderFns } from "./AppPhoneInput.vue?vue&type=template&id=fe5bf8fe&"
import script from "./AppPhoneInput.vue?vue&type=script&lang=js&"
export * from "./AppPhoneInput.vue?vue&type=script&lang=js&"
import style0 from "./AppPhoneInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports